/**
 * A recusa que encerra a tela da organização (#767).
 *
 * "Sem permissão" (a concessão de Super Admin acabou) e "não encontrado" não
 * mudam ao repetir. O que já estava na memória
 * não pode continuar à vista depois de uma delas: a ficha mostra o nome e o
 * e-mail dos administradores. As outras falhas (rede, servidor fora) deixam a
 * tela com o que tinha, e o erro aparece só quando não há nada a mostrar.
 */

import { ErroDaApi } from '@cliqcrm/contracts';

export function encerraATela(erro: unknown): boolean {
  return (
    erro instanceof ErroDaApi &&
    (erro.codigo === 'SEM_PERMISSAO' || erro.codigo === 'NAO_ENCONTRADO')
  );
}
